import { DecimalUnitKind, DecimalUnitOptions } from '../schema';
import { FormatValueOptions, UnitGroupConfig, UnitConfig } from './types';
import { hasDecimalPlaces, limitDecimalPlaces, shouldAbbreviate } from './utils';

export const DECIMAL_GROUP_CONFIG: UnitGroupConfig = {
  label: 'Decimal',
  decimal_places: true,
  abbreviate: true,
};

export const DECIMAL_UNIT_CONFIG: Readonly<Record<DecimalUnitKind, UnitConfig>> = {
  Decimal: {
    group: 'Decimal',
    label: 'Decimal',
  },
};

type FormatDecimalOptions = DecimalUnitOptions & Pick<FormatValueOptions, 'trimZeros'>;

export function formatDecimal(
  value: number,
  { abbreviate, decimal_places, trimZeros = true }: FormatDecimalOptions
): string {
  const formatterOptions: Intl.NumberFormatOptions = {
    style: 'decimal',
    useGrouping: true,
  };

  if (shouldAbbreviate(abbreviate)) {
    formatterOptions.notation = 'compact';
  }

  if (hasDecimalPlaces(decimal_places)) {
    formatterOptions.maximumFractionDigits = limitDecimalPlaces(decimal_places);
    if (!trimZeros) {
      formatterOptions.minimumFractionDigits = limitDecimalPlaces(decimal_places);
    }
  } else {
    if (Math.abs(value) < 1) {
      // For values < 1, allow up to 3 significant digits
      formatterOptions.maximumSignificantDigits = 3;
    } else {
      // For values >= 1, allow up to 2 decimal places.
      formatterOptions.maximumFractionDigits = 2;
    }
  }

  const formatter = Intl.NumberFormat('en-US', formatterOptions);
  return formatter.format(value);
}
